module.exports = __webpack_public_path__ + "img/img-float-1.5b5d17e5.png";